/**
 * Easter egg: raining carrots when an expense of 69 is added.
 * To remove: delete this file, remove its import/usage from App.js,
 * and remove the dispatch in AddRecordModal (search for "carrot-rain").
 */
import React, { useState, useEffect, useCallback } from 'react';
import styles from './CarrotRainEasterEgg.module.css';

const CARROT = '🥕';
const COUNT = 40;
const DURATION_MS = 12000;

function CarrotRainEasterEgg() {
	const [visible, setVisible] = useState(false);

	const show = useCallback(() => setVisible(true), []);
	const hide = useCallback(() => setVisible(false), []);

	useEffect(() => {
		let timeoutId;
		const handler = () => {
			show();
			timeoutId = setTimeout(hide, DURATION_MS);
		};
		window.addEventListener('carrot-rain', handler);
		return () => {
			window.removeEventListener('carrot-rain', handler);
			if (timeoutId) clearTimeout(timeoutId);
		};
	}, [show, hide]);

	if (!visible) return null;

	return (
		<div className={styles.overlay} aria-hidden='true'>
			{Array.from({ length: COUNT }, (_, i) => (
				<span
					key={i}
					className={styles.carrot}
					style={{
						left: `${(i * 97) % 100}%`,
						animationDelay: `${(i * 0.15) % 4}s`,
						animationDuration: `${4 + (i % 3)}s`,
					}}
				>
					{CARROT}
				</span>
			))}
		</div>
	);
}

export default CarrotRainEasterEgg;
